/* eslint-disable no-undef */
/* eslint-disable object-shorthand */
import { client } from './client';

export const loadList = (params = {}) => client.get('chargebacks', { params });
export const sendReceipt = params => client.post('chargebacks/send_receipt', params);
